<template>
  <label class="checkbox">
    <input type="checkbox" :checked="modelValue" @change="onChange" />
    <span class="checkmark"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:model-value"],
  methods: {
    onChange(event) {
      this.$emit("update:model-value", event.target.checked);
    },
  },
};
</script>

<style scoped>
.checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem; 
  cursor: pointer;
  position: relative;
  user-select: none;
  font-size: 1rem; 
}

.checkbox input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.checkmark {
  width: 1rem;
  height: 1rem;
  background-color: var(--color-0);
  border: 0.0625rem solid var(--grey-2, #ccc); /* 1px */
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
  transition: all 0.2s;
}

.checkmark::after {
  content: "";
  position: absolute;
  left: 0.34rem;
  top: 0.16rem;
  width: 0.25rem;
  height: 0.5rem;
  border: solid var(--color-1);
  border-width: 0 0.125rem 0.125rem 0;
  transform: rotate(45deg);
  opacity: 0.2; /* изначальная прозрачность */
  transition: opacity 0.2s;
}

.checkbox input:checked + .checkmark::after {
  opacity: 1; /* при выборе полностью видно */
}
</style>
